@if (isModalOpen()) {
  <div class="special-access-card">
    <div class="special-access-header">
      <div class="special-access-title">
        <mat-icon svgIcon="DIAMOND_ACCESS"></mat-icon>
        <span>{{ isUserInGroup ? 'Special Access Request Queue' : 'Special Access Group' }}</span>
      </div>
      @if (isUserInGroup) {
        <button class="close-button-icon" (click)="closeModal()">
          <mat-icon> close </mat-icon>
        </button>
      }
    </div>
    @if (isUserInGroup) {
      <div class="queue-content-wrapper">
        <span class="queue-title">{{
          queue().length
            ? 'These people want to join your group'
            : 'People who want to join your group will appear here'
        }}</span>
        <div class="queue-card-list">
          @for (user of queue(); track user.userId) {
            <div class="queue-card">
              <div class="user-wrapper">
                <profile-picture [user]="user" [size]="48" [borderWidth]="'0'"></profile-picture>
                <div class="user-info-wrapper">
                  <span class="user-name" title="{{ getUsersDisplayName(user) }}">{{
                    getUsersDisplayName(user) | truncate: 24
                  }}</span>
                  <span class="user-info">{{ getTitleCompanyInfo() }}</span>
                </div>
              </div>
              <div class="queue-card-actions">
                <button class="button-white" (click)="rejectAccessRequest(user.userId)">Dismiss</button>
                <button (click)="acceptAccessRequest(user.userId)">Admit</button>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <button class="permision-button" [disabled]="disableRequestAccessBtn" (click)="requestAccess()">
        {{ disableRequestAccessBtn ? 'Request sent' : 'Ask to join conversation' }}
      </button>
    }
  </div>
}
